import React from 'react';
import { Box, Typography } from '@mui/material';
import { InvestorStatementEmailTemplateData } from '../../../models/admin/InvestorStatement';
import { Palette } from 'Palette';
import EmailPreviewIframe, { EmailPreviewIframeRef } from '../EmailPreviewIframe';
import InvitationEmailEditHintBubble from '../InvitationEmailEditHintBubble';
import { InvitationEmailEditHintPosition } from '../generateInvitationEmailTypes';

const tone: keyof typeof Palette = 'default';

interface StatementEmailContentEditorProps {
  templateData: InvestorStatementEmailTemplateData;
  customHtml: string;
  emailPreviewRef: React.RefObject<EmailPreviewIframeRef>;
  iframeContainerRef: React.RefObject<HTMLDivElement>;
  showSpeechBubble: boolean;
  elementPosition: InvitationEmailEditHintPosition | null;
  onContentChange: (html: string) => void;
  onEnterEditMode: () => void;
  onElementPosition: (position: { top: number; left: number }) => void;
  onHideSpeechBubble: () => void;
}

/** The editable email-body preview (iframe + click-to-edit hint) for StatementEmailComposePanel. */
const StatementEmailContentEditor: React.FC<StatementEmailContentEditorProps> = ({
  templateData,
  customHtml,
  emailPreviewRef,
  iframeContainerRef,
  showSpeechBubble,
  elementPosition,
  onContentChange,
  onEnterEditMode,
  onElementPosition,
  onHideSpeechBubble,
}) => (
  <Box sx={{ p: 2 }}>
    <Typography
      variant="body2"
      sx={{
        mb: 2,
        color: Palette[tone].disabledText || '#666',
        fontSize: '0.75rem',
        fontWeight: 500,
      }}
    >
      Email Content (click the highlighted section to edit your custom message)
    </Typography>

    <Box sx={{ position: 'relative' }}>
      <Box
        ref={iframeContainerRef}
        sx={{
          border: `1px solid ${Palette[tone].border}`,
          borderRadius: '4px',
          overflow: 'auto',
          backgroundColor: '#f5f5f5',
          position: 'relative',
          maxHeight: '600px',
          minHeight: '400px',
          isolation: 'isolate',
        }}
      >
        <EmailPreviewIframe
          ref={emailPreviewRef}
          templateHtml={templateData.html}
          customHtml={customHtml || ''}
          onContentChange={onContentChange}
          onEnterEditMode={onEnterEditMode}
          onExitEditMode={() => {}}
          onElementPosition={onElementPosition}
          onHideSpeechBubble={onHideSpeechBubble}
        />
      </Box>

      {showSpeechBubble && elementPosition && (
        <InvitationEmailEditHintBubble position={elementPosition} />
      )}
    </Box>
  </Box>
);

export default StatementEmailContentEditor;
